import React, { useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box, Typography } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import { ComboBox } from "../../uiControls/comboBox";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import { StatusControl } from "../../uiControls/statusControl";
import * as utils from "../../common/utils";

const initialUserIsValid = {
  name: "",
  email: "",
  roleKey: "",
};

export const UserUpdate = (props) => {
  const { roles, setUpdateOpen, userAttributes } = props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateUser } = useHttpRequests();

  const [userDetails, setUserDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    userAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialUserIsValid
  );

  const updateUserDetailsValue = (_key, value) => {
    setUserDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    if (typeof _key === "object") {
      setIsValid({ ...isValid, ..._key });
    } else {
      setIsValid({ ...isValid, [_key]: errMsg + header });
    }
  };

  const onChangeHandler = (e, controlName) => {
    updateUserDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };

  const dropDownChangeHandler = (id, value) => {
    if (value?.id) {
      updateUserDetailsValue("roleKey", value.id);
    } else {
      updateUserDetailsValue("roleKey", 0);
    }
  };

  const cancelUserHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setUpdateOpen(false);
  };

  const validateUserDetails = () => {
    setIsValid(initialUserIsValid);

    var errorSummary = "";

    if (
      userDetails.email !== "" &&
      !utils.validateEmail(userDetails["email"])
    ) {
      updateErrorMessage("email", "Email", "Enter ");
      errorSummary += "Enter valid email. \n";
    }

    if (!userDetails.roleKey || userDetails.roleKey <= 0) {
      updateErrorMessage("roleKey", "Role", "Select ");
      errorSummary += "Select role. \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      const dataObj = userDetails;
      delete dataObj["userBrief"];
      delete dataObj["name"];
      delete dataObj["roleTitle"];

      const getUpdateUserResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "User updated successfully!",
          })
        );
        setTimeout(() => {
          cancelUserHandler();
        }, 2000);
      };

      updateUser(
        {
          url: "Users/" + dataObj["userKey"],
          method: "PUT",
          body: dataObj,
        },
        getUpdateUserResponse
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "5px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <MessageDisplay />

          <Typography>
            <label>Brief:</label> {userDetails.userBrief}
          </Typography>
          <Typography>
            <label>Name:</label> {userDetails.name}
          </Typography>

          <InputText
            type="email"
            label="Email"
            id={"userDetails.email"}
            isError={isValid["email"] !== ""}
            value={userDetails["email"]}
            onChange={(e) => onChangeHandler(e, "email")}
            isRequired={false}
          />
          <ComboBox
            id={"userDetails.roleKey"}
            label="Role"
            isError={isValid["roleKey"] !== ""}
            isRequired={true}
            isDisabled={false}
            selectedValue={userDetails["roleTitle"]}
            list={roles}
            onChange={dropDownChangeHandler}
          />

          <StatusControl
            label="Active"
            isRequired={false}
            fieldName={"active"}
            active={userDetails.active}
            updateStatusValue={updateUserDetailsValue}
          />
          <SaveCancel
            cancelCall={() => cancelUserHandler()}
            saveCall={() => validateUserDetails()}
          />
        </div>
      </Box>
    </>
  );
};
